export const transactions = [
  {
    "description": "Received $4,000 cash advance from a client for future deliveries."
  }
];
export const answerOptions = [
    "Increase Profits",
    "Decrease Profits",
    "No Impact"
];